/* eslint-disable import/no-named-as-default */
/* eslint-disable import/extensions */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable react-native/no-inline-styles */
import HeaderWithSearch from "@components/SearchHeader/HeaderWithSearch";
import React, { useCallback, useEffect } from "react";
import { BackHandler, FlatList, ActivityIndicator, View } from "react-native";
import SearchIcon from "@assets/svg/SearchIcon";
import { colors } from "@constants/theme";
import { getOrderUsersList } from "@services/api";
import useSarvCall from "@hooks/useSarvCall";
import { debounce } from "lodash";
import EmptySearchList from "@components/SearchHeader/EmptySearchList";
import { useFocusEffect, useIsFocused } from "@react-navigation/native";
import t from "@constants/localization";
import CustomerCard from "./components/CustomerCard";
import CratePackedModal from "./components/CratePackedModal";
import SarvCallModal from "../../MyTasks/components/SarvCallModal.tsx";

function CrateCustomerList({ navigation, route }) {
  const { crate, type } = route.params;
  const [isSearchEnabled, setIsSearchEnabled] = React.useState(false);
  const [listData, setListData] = React.useState({});
  const isFocused = useIsFocused();
  const [filteredListData, setFiltedListData] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);
  const [fullCratePackedModal, setFullCratePackedModal] = React.useState(false);
  const { createCall, showSarvModal, setShowSarvModal, updateSarvData } =
    useSarvCall();

  const PATH = "screens/MyDeliveries/SortingDeliveries/crateCustomerList";

  useFocusEffect(
    useCallback(() => {
      if (isFocused) {
        fetchData();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFocused]),
  );
  const fetchData = async () => {
    setIsLoading(true);
    try {
      let payload = crate?.next_payload;
      if (type === "MY_ORDERS") {
        payload = { ...payload, filterType: "MY_ORDERS" };
      } else {
        payload = { ...payload, filterType: "ALL" };
      }
      const { data } = await getOrderUsersList(payload);
      setListData(data);
      setFiltedListData(data);
      updateSarvData(data);
      if (route.params?.from === "SortingItemList") {
        const packedCount = data?.data?.filter(
          (item) => item?.status === "PACKED",
        ).length;

        data?.data?.some((item) => {
          if (item?.status === "NOT_PACKED") {
            navigation.replace("SortingItemList", {
              user_name: item?.cx_name,
              orders_list: item?.order_ids,
              user_id: item?.cx_id,
              user_phone: item?.cx_phone,
              date: route.params?.date,
              spokeName: route.params?.spoke,
              type: route.params?.crate?.type,
              db_name: item?.db_name,
              bags: item?.bags,
              route_name: item?.route_name,
              route_id: item?.route_id,
              crate: route.params?.crate,
              shipment_ids: item?.shipment_ids,
              unique_key: item?.unique_key,
              status: item?.status,
              bags_disabled: item?.bags_disabled,
              cx_packing_enabled: item?.cx_packing_enabled,
              fragile_order_ids: item?.fragile_order_ids,
              top_sku_order_ids: item?.top_sku_order_ids,
            });
            return true;
          }
          return false;
        });
        if (packedCount === data?.data?.length) {
          setFullCratePackedModal(true);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const backHandler = () => {
      if (isSearchEnabled) {
        setIsSearchEnabled((prev) => !prev);
        return true;
      }
      return false;
    };

    const backHandlerSub = BackHandler.addEventListener(
      "hardwareBackPress",
      backHandler,
    );

    return () => {
      backHandlerSub.remove();
    };
  }, [isSearchEnabled]);
  const onSearchInputChange = debounce((text) => {
    if (text === "") {
      setFiltedListData(listData);
      return;
    }
    const filteredData = listData?.data?.filter((item) => {
      return (
        item.cx_name.toLowerCase().includes(text.toLowerCase()) ||
        item.cx_phone.toLowerCase().includes(text.toLowerCase()) ||
        item.cx_formatted_address.toLowerCase().includes(text.toLowerCase())
      );
    });
    setFiltedListData({ ...listData, data: filteredData });
  }, 500);

  // PACKING TRIP-CARD SPLIT -- key by (card_id, cx_id), NEVER cx_id alone.
  // This is B-1/C-1 in mirror image (see CpDeliveryRoutes/cardHelpers.js's
  // cardDraftKey, the shipped precedent this follows): a customer can now
  // hold several cards (one per live trip, plus an untagged one), each
  // carrying the SAME cx_id but a distinct card_id. Keying on cx_id alone
  // would collide across those cards -- duplicate FlatList keys and cross-
  // card state bleed, the mirror image of two customers sharing one trip
  // colliding on trip_card_id alone on the touchpoints screen. `item.card_id`
  // is only emitted with the multi-trip flag ON (§5 byte-identical rule); the
  // legacy branch below is unchanged for a flag-OFF / pre-migration response.
  const keyExtractor = (item, _index) =>
    item?.card_id
      ? `${item.card_id}|${item?.cx_id ?? ""}`
      : String(item?.cx_id ?? "");

  const renderItem = ({ item }) => {
    return (
      <CustomerCard
        item={item}
        navigation={navigation}
        route={route}
        createCall={createCall}
      />
    );
  };
  return (
    <View style={{ flex: 1 }}>
      <HeaderWithSearch
        headertitle={listData?.title || t(`${PATH}/headerTitle`)}
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
        searchPlaceholder={t(`${PATH}/SearchPlaceholder`)}
        isSearchEnabled={isSearchEnabled}
        searchIcon={<SearchIcon height={24} width={24} />}
        onPressSearchIcon={() => setIsSearchEnabled(true)}
        goingBackHandler={() => {
          if (isSearchEnabled) setIsSearchEnabled(false);
          else navigation.goBack();
        }}
        onSearchInputChange={onSearchInputChange}
        onPressCrossIcon={() => onSearchInputChange("")}
      />
      {isLoading ? (
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      ) : filteredListData?.data?.length === 0 ? (
        <EmptySearchList />
      ) : (
        <FlatList
          keyExtractor={keyExtractor}
          contentContainerStyle={{ paddingBottom: 20 }}
          data={filteredListData?.data || []}
          renderItem={renderItem}
          keyboardShouldPersistTaps="handled"
        />
      )}
      <SarvCallModal
        showSarvModal={showSarvModal}
        setShowSarvModal={setShowSarvModal}
      />
      <CratePackedModal
        cratePackedModalVisible={fullCratePackedModal}
        setcratePackedModalVisible={setFullCratePackedModal}
        onPressBtn={() => {
          setFullCratePackedModal(false);
          navigation.pop(2);
        }}
        onPressCross={() => {
          setFullCratePackedModal(false);
          navigation.pop(1);
        }}
        type={crate?.type || "crate"}
      />
    </View>
  );
}

export default CrateCustomerList;
